(function() {
	'use strict';

	angular.module('nasracApp').config(
			[ '$compileProvider', function($compileProvider) {
				$compileProvider.aHrefSanitizationWhitelist(/^\s*(|blob|):/);
			} ]).controller('NonNctcController', NonNctcController);

	NonNctcController.$inject = [ '$scope', 'NonNctc', 'AuthServerProvider',
			'DTOptionsBuilder' ];

	function NonNctcController($scope, NonNctc, AuthServerProvider,
			DTOptionsBuilder) {
		//var vm = this;
        $scope.selectedMonth;

        $scope.loadData = function() {
			if (!$scope.selectedMso || !$scope.selectedMso.msoName || $scope.selectedMso.msoName == null) {
				$scope.selectedMso = {};
				$scope.selectedMso.msoName = undefined;
			}
			NonNctc.query({
				msoName : $scope.selectedMso.msoName,
				date : $scope.selectedMonth.reportDate.substring(0, 10)
			}, function(result) {
                $scope.date = $scope.selectedMonth;
                $scope.nonNctcList = result;
                $scope.currentTime = new Date(new Date().getTime()).toLocaleTimeString() + ' ' + moment.tz(moment.tz.guess()).zoneAbbr();//getting current time
                $scope.getTotal(result);

			});
		};
				$scope.getTotal = function (result){
					$scope.total = {};
					$scope.total.digitalMot = 0;
					$scope.total.digitalNonMot = 0;
					$scope.total.dta = 0;
					$scope.total.setTopCount = 0;
					$scope.total.stdRateCharges = 0;
					$scope.total.minimumFee = 0;
					$scope.total.serviceCharge = 0;
					angular.forEach(result,function(nonNctc,index){
						$scope.total.digitalMot = $scope.total.digitalMot + nonNctc.digitalMot;
						$scope.total.digitalNonMot = $scope.total.digitalNonMot + nonNctc.digitalNonMot;
						$scope.total.dta = $scope.total.dta + nonNctc.dta;
						$scope.total.setTopCount=$scope.total.setTopCount+nonNctc.setTopCount;
						$scope.total.stdRateCharges =$scope.total.stdRateCharges +nonNctc.stdRateCharges;
						$scope.total.minimumFee = $scope.total.minimumFee+nonNctc.minimumFee;
						$scope.total.serviceCharge = $scope.total.serviceCharge + nonNctc.serviceCharge;
				});
			};

		NonNctc.getReportDates(function(result) {
			$scope.reportDate = result;
            $scope.selectedMonth = result[0];
			$scope.onDateChange();
		});

		$scope.onDateChange = function() {
			//console.log($scope.selectedMonth.reportDate);

			NonNctc.getMsoNames({
				date : $scope.selectedMonth.reportDate.substring(0, 10)
			}, function(result) {
				$scope.msoList = result;
				$scope.selectedMso = "";
			});
		};

		$scope.dtOptions = DTOptionsBuilder.newOptions().withDisplayLength(25)
            .withPaginationType('full_numbers')
            .withButtons(
				[ {
					//extend: 'csvHtml5', // removing action column TODO : remove action header
					text : 'Export',
					key : '1',
					action : function(e, dt, node, config) {
						/*var msoName;
						if ($scope.selectedMso === "" || $scope.selectedMso.msoName == null) {
							msoName = undefined;
						} else {
							msoName = parseInt($scope.selectedMso.msoName);
						}*/
						NonNctc.download({
							msoName : $scope.selectedMso.msoName,
							date : $scope.selectedMonth.reportDate.substring(0,10)
						}).$promise.then(function(data) {
							var url = URL.createObjectURL(data.response);
							var link = document.createElement("a");
							link.href = url;

							//set the visibility hidden so it will not effect on your web-layout
							link.style = "visibility:hidden";
							link.download = "Authorization_Fee_summary_For_NonNCTC_"+$scope.selectedMonth.reportDateLabel+".xlsx"; //this is an example file to download, use yours

							//this part will append the anchor tag and remove it after automatic click
							document.body.appendChild(link);
							link.click();
							document.body.removeChild(link);
						});
					}
				} ]).withDOM(
		                "<'row'<'col-sm-3'l><'col-sm-6 text-center'B><'col-sm-3'f>>" +
		                "<'row'<'col-sm-12'tr>>" +
		                "<'row'<'col-sm-5'i><'col-sm-7'p>>");

	}
})();
